import React from 'react'
import { AnimatePresence, motion } from 'motion/react';

const HighlightsImage = ({ image }) => {
	if (!image) return null;

	return (
		<div className="highlights__image">

			<AnimatePresence mode="wait">
				<motion.img
					key={image}
					src={image}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{
						duration: 0.2,
						ease: 'easeInOut',
					}}
				/>
			</AnimatePresence>
		</div>
	)
}

export default HighlightsImage
